import React from 'react'
import styled from 'styled-components'
import OnSelectMenuProvider from 'context/general/OnSelectMenu'
import CollapseProvider from 'context/general/Collapse'
import Topbar from 'components/commons/Topbar'
import Navbar from 'components/commons/Navbar'
import DashHeaderActions from 'modules/dashboard/_common/DashHeaderActions'
import Affiliate from 'modules/dashboard/affiliate/Affiliate'
import colors from 'theme/colors'
import breakpoints from 'theme/breakpoints'

export default function AffiliateProgram() {
  return (
    <OnSelectMenuProvider>
      <CollapseProvider>
        <PageContainer>
          <Topbar />

          {/* Executa as ações do dropdown do Topbar (sair, termos, alterar senha). */}
          <DashHeaderActions />

          <ContentArea>
            <PageHeading>
              <PageTitle>Programa de indicação</PageTitle>
              <PageSubtitle>
                Convide produtores e estabelecimentos para a Whizr e acompanhe aqui o prazo de cada indicação.
              </PageSubtitle>
            </PageHeading>

            <Affiliate />
          </ContentArea>

          <Navbar />
        </PageContainer>
      </CollapseProvider>
    </OnSelectMenuProvider>
  )
}

const PageContainer = styled.div`
  min-height: 100vh;
  background: ${colors.neutralBackground};
  display: flex;
  flex-direction: column;
`

const ContentArea = styled.main`
  width: 100%;
  max-width: 680px;
  margin: 0 auto;
  padding: 20px 16px 100px;

  @media screen and (min-width: ${breakpoints.sm}) {
    padding: 28px 20px 48px;
  }
`

const PageHeading = styled.div`
  margin-bottom: 18px;
`

const PageTitle = styled.h1`
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  letter-spacing: -0.4px;
  color: ${colors.nightDark};

  @media screen and (min-width: ${breakpoints.sm}) {
    font-size: 26px;
  }
`

const PageSubtitle = styled.p`
  margin: 6px 0 0;
  font-size: 14px;
  line-height: 1.5;
  color: ${colors.night};
`
